import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect } from "react";
import Text from "src/components/Displays/Text";
import { SESSION_KEYS } from "src/consts/session";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { authenticationCallback } from "src/api/selfOnboardingClients";
import { SELF_ONBOARDING_PATHS } from "src/consts/Routes/SelfOnboarding";

const Start = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const [getTransferId] = useSessionStorage<string>(SESSION_KEYS.TRANSFER_ID);

  const initialCall = useCallback(async () => {
    const transferId = getTransferId();
    if (!transferId) return;
    try {
      const response = await authenticationCallback({
        transferId: transferId,
        searchParams: window.location.search,
      });

      setTimeout(() => {
        if (response.msgId === "success") {
          navigate(SELF_ONBOARDING_PATHS.ACCESS_SUCCESS);
        } else {
          navigate(SELF_ONBOARDING_PATHS.ACCESS_FAILED);
        }
      }, 1000);
    } catch (e) {
      const error = e as Error;
      navigate(SELF_ONBOARDING_PATHS.ACCESS_FAILED + `?msgId=${error.msgId}`);
    }
  }, [getTransferId, navigate]);

  useEffect(() => {
    initialCall();
  }, [initialCall]);

  return (
    <Stack gap={5}>
      <Text
        text={t("page.selfOnboardingStatusAuthenticationCallback.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.selfOnboardingStatusAuthenticationCallback.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <PrimaryButton
        fullWidth
        text={t("page.siteAuthenticationStart.nextButton")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "20px",
          maxWidth: { sm: "320px" },
          color: theme.palette.mainFont.primary,
        })}
        isLoading={true}
      />
    </Stack>
  );
};

export default Start;
